import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt'; 
import { UserProfile } from '../_models/authModel';
const USER_KEY = 'auth-user-rental';
const TOKEN_KEY = 'access-token-rental';
/** key ของ session ทั้งหมด — ล้างเฉพาะชุดนี้ ไม่ใช้ localStorage.clear() (ล้าง key อื่นของ origin เดียวกันไปด้วย) */
const SESSION_KEYS = [TOKEN_KEY, USER_KEY, 'permission', 'redirectAfterLogin'];

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  jwtHelper = new JwtHelperService();
  constructor() {}

  /**
   * ออกจากระบบ: ลบเฉพาะ key ของ session
   * ⚠️ localStorage ใช้ร่วมกันทุกแท็บ — เรียกเฉพาะตอนผู้ใช้กดออกจากระบบ หรือ token ใช้ไม่ได้แล้ว
   *    ห้ามเรียกแค่เพราะเปิดหน้า login (เคยทำ ⇒ แท็บไหนเปิด/reload หน้า login ก็ทำให้ทุกแท็บหลุด)
   */
  clean(): void {
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public saveUser(user: UserProfile): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): UserProfile {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {
      id:'',
      roleCode: '',
      roleName: '', 
      avatarUrl: '',
      email: '',
      fullName: '', 
      phone: '',
      userCode: '',
      position: '',
    };
  }

  loggedIn() {
    const token = localStorage.getItem(TOKEN_KEY);
    return !this.jwtHelper.isTokenExpired(token || '');
  }
}
